<div
	class="group-button"
	[class.group-button--disabled]="disabled"
	[class.group-button--variant]="isVariant"
	role="group"
>
	<button
		*ngFor="let option of options; trackBy: trackByValue"
		type="button"
		class="group-button__item paragraph-medium"
		[class.group-button__item--selected]="isSelected(option.value)"
		[class.first]="isFirst(option.value)"
		[disabled]="disabled"
		(click)="selectOption(option.value)"
	>
		<ng-container *ngIf="option.label; else translatedLabelTpl">{{ option.label }}</ng-container>
		<ng-template #translatedLabelTpl>{{ option.labelKey | translate }}</ng-template>
	</button>
</div>
